import React from 'react'
import PropTypes from 'prop-types'
import { Button, Link } from './style'

const MuiButton = (props) => {
  let toUrl
  let object = {}
  const content = props?.children || props?.label || props?.title || ''

  const _delete = () => {
    const keys = Object.keys(props)
    keys.map((k) => {
      if (k !== 'to') object[k] = props[k]
      return k
    })
  }

  if (props?.to) {
    toUrl = props.to
    _delete()
  } else {
    object = props
  }

  return (
    <>
      {toUrl ? (
        <Link to={toUrl}>
          <Button
            {...object}
            className={`${props?.className} ${content?.length > 0 ? 'hasTitle' : 'noTitle'}`}
          >
            {content}
          </Button>
        </Link>
      ) : (
        <Button
          {...object}
          className={`${props?.className} ${content?.length > 0 ? 'hasTitle' : 'noTitle'}`}
        >
          {content}
        </Button>
      )}
    </>
  )
}
export default MuiButton

MuiButton.propTypes = {
  variant: PropTypes.oneOf(['text', 'outlined', 'contained']),
  title: PropTypes.string,
  label: PropTypes.string,
  to: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  disabled: PropTypes.bool,
  shadow: PropTypes.bool,
  compact: PropTypes.bool,
  fullWidth: PropTypes.bool,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  children: PropTypes.node,
  onClick: PropTypes.func,
}
